export enum StatisticsVisualizationEnum {
  Quantity = 'QUANTITY',
  Value = 'VALUE',
}
